import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Lock, Phone } from "lucide-react";
import { CATEGORIES } from "@/lib/categories";
import { AIR_BENGUE } from "@/lib/airBengue";

const nomRubrique = (c) => (c === "air" ? AIR_BENGUE.name : CATEGORIES[c]?.name || c);

/**
 * Bandeau de conversion. Les photos sont désormais TOUJOURS nettes (03/07/2026) :
 * le bandeau ne parle donc plus que des NUMÉROS, réservés aux abonnés de la rubrique
 * (abonnement sur une autre rubrique, abonnement expiré, ou aucun abonnement).
 */
export const BandeauApercu = ({ apercu, categorie }) => {
  if (!apercu.connecte || apercu.admin) return null;
  if (apercu.acces?.[categorie]) return null;

  const rubrique = nomRubrique(categorie);
  const expire = apercu.expires?.[categorie];
  const autresUniques = [...new Set((apercu.abonnements || []).map((a) => nomRubrique(a.category)))];

  let message;
  if (expire) {
    message = (
      <>
        Votre abonnement {rubrique} a <b className="text-stone-900">expiré le {expire.slice(0, 10)}</b>.
        Renouvelez-le pour débloquer les numéros de cette rubrique.
      </>
    );
  } else if (autresUniques.length > 0) {
    message = (
      <>
        Votre abonnement <b className="text-stone-900">{autresUniques.join(" + ")}</b> ne donne pas
        accès aux <b className="text-stone-900">numéros {rubrique}</b>. Ajoutez cette rubrique pour
        contacter les annonceurs.
      </>
    );
  } else {
    message = (
      <>
        Toutes les photos sont en clair. Les <b className="text-stone-900">numéros {rubrique}</b> sont
        réservés aux abonnés : abonnez-vous pour appeler directement les annonceurs.
      </>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      data-testid="bandeau-apercu"
      data-etat={expire ? "expire" : autresUniques.length ? "autre-rubrique" : "verrouille"}
      className="mb-6 flex flex-col sm:flex-row sm:items-center gap-3 rounded-2xl border border-[#E05638]/30 bg-[#E05638]/[0.07] px-4 py-3"
    >
      <span className="inline-flex items-center gap-2 text-sm font-bold text-[#E05638]">
        {expire ? <Lock size={16} /> : <Phone size={16} />}
        {expire ? "Abonnement expiré" : "Numéros non inclus"}
      </span>
      <p className="flex-1 text-sm text-stone-600">{message}</p>
      <Link
        to="/abonnement"
        data-testid="bandeau-apercu-abonnement"
        className="inline-flex items-center gap-1.5 rounded-full bg-[#12100E] px-4 py-2 text-sm font-semibold text-white transition-transform hover:scale-[1.03]"
      >
        {expire ? "Renouveler" : autresUniques.length ? `Ajouter ${rubrique}` : "S'abonner"}{" "}
        <ArrowRight size={14} />
      </Link>
    </motion.div>
  );
};
